module.exports = __webpack_public_path__ + "img/img_modD2.b843aa26.png";